import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import SectionV2 from './Section/v2';
import { ObjModal } from '../../../contexts';
import Comms from './Tab/comms';
import Biz from './Tab/biz';


const DetailsV3 = ( { aid, layout, commsLoaded } ) => {
    const [ view, setView ] = useState( [] );
    const { obj, objType, getValue } = useContext( ObjModal );
    const [ hasTabs, setHasTabs ] = useState( false );
    const [ tabs, setTabs ] = useState( [] );
    
    const shouldRenderSection = ( section ) => {
        if ( !section.conditional ) return true;
        const currentValue = getValue( section.conditional.db );
        return currentValue === section.conditional.value;
    };

    const renderSection = ( view ) => {
        return view.map( ( v, idx ) => {
            let show = true;
            if ( v.conditional ) {
                console.log( 'cond: ', v.conditional );
                switch ( v.conditional.operator ) {
                    case 'valid':
                        console.log( obj.details[v.conditional.db] );
                        show = ( obj.details[v.conditional.db] !== undefined );
                        break;

                    default:
                        show = ( obj.details[v.conditional.db] === v.conditional.value );
                }
            }
            if ( show ) {
                return <SectionV2 key={`section-${idx}`} title={v.title} body={v.body} id={v.id ??  'gen'} />;
            }
            return null;
        } );
    };

    useEffect( () => {
        if ( layout && obj.details ) {
            if ( layout.map.key && layout.map.layouts[obj.details[layout.map.key]] ) {
                setView( layout.map.layouts[obj.details[layout.map.key]] );
            } else {
                setView( layout.map.layouts['*'] );
            }

            if ( layout.map.tabs ) {
                setHasTabs( true );
                if ( layout.map.key && layout.map.tabs[obj.details[layout.map.key]] ) {
                    setTabs( layout.map.tabs[obj.details[layout.map.key]] );
                } else {
                    setTabs( layout.map.tabs['*'] );
                }
            } else {
                setHasTabs( false );
            }
        }
    }, [ layout, obj.details ] );

    useEffect( () => {
        if ( obj.comms && obj.comms.length ) {
            console.log( 'sorting: ', obj.comms );
        }
        obj?.comms?.sort( ( a, b ) => {
            let ad = Date.parse( a.commDate );
            let bd = Date.parse( b.commDate );

            if ( !ad ) {
                ad = Date.parse( a.createdDate );
            }
            if ( !bd ) {
                bd = Date.parse( b.createdDate );
            }
            return bd - ad;
        } );
        // console.log( obj.comms );
    }, [ obj.comms ] );

    return (
        <Container fluid className='p-0'>
            {
                ( hasTabs ) ? (
                    <Tabs defaultActiveKey="details" id="tf-contact-details" className="m-0">
                        <Tab eventKey="details" title="Main Details">
                            {
                                renderSection( view )
                            }
                        </Tab>
                        {
                            tabs.map( ( t, idx ) => {
                                switch ( t ) {
                                    case 'comms':
                                        return <Tab key={`tab-${idx}`} eventKey="comms" title="Comms"><Comms /></Tab>;

                                    case 'biz':
                                        return <Tab key={`tab-${idx}`} eventKey="biz" title="Business With"><Biz /></Tab>;
                                        
                                    default:
                                }
                                return null;
                            } )
                        }
                    </Tabs>
                ) : (
                    renderSection( view )
                )
            }
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    commsLoaded: state.comms.loaded
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( DetailsV3 );